export var convertCamelToKebabCase = function (str) {
    return str.replace(/[A-Z0-9]+(?![a-z])|[A-Z0-9]/g, function ($, ofs) { return (ofs ? "-" : "") + $.toLowerCase(); });
};
export var convertKebabToCamelCase = function (str) {
    return str.replace(/-([a-z])/g, function (_, letter) { return letter.toUpperCase(); });
};
export var pxToRem = function (str, fontSize) {
    if (fontSize === void 0) { fontSize = 20; }
    return (Number(str.replace(/px/, '')) / fontSize) + 'rem';
};
